{
  "days": [
    {
      "value": "mon",
      "selected": true
    },
    {
      "value": "tue",
      "selected": false
    },
    {
      "value": "wed",
      "selected": true
    },
    {
      "value": "thu",
      "selected": false
    },
    {
      "value": "fri",
      "selected": true
    },
    {
      "value": "sat",
      "selected": false
    },
    {
      "value": "sun",
      "selected": false
    }
  ]
}
